export const CLIENT_PLATFORM_HEADER = "X-LiftFlow-Client-Platform";
export const CLIENT_PLATFORM_WEB = "web";
export const CLIENT_PLATFORM_ANDROID_TWA = "android_twa";

const CLIENT_PLATFORM_SESSION_STORAGE_KEY = "__liftflow_client_platform";

function normalizeClientPlatform(value) {
  return String(value || "").trim().toLowerCase() === CLIENT_PLATFORM_ANDROID_TWA
    ? CLIENT_PLATFORM_ANDROID_TWA
    : CLIENT_PLATFORM_WEB;
}

function hasBufferedAndroidTwaBridgePort() {
  try {
    return window.__liftflowAndroidTwaBridgeBootstrap?.port instanceof MessagePort;
  } catch (_) {
    return false;
  }
}

function readBootstrappedClientPlatform() {
  try {
    return normalizeClientPlatform(window.__liftflowAndroidTwaBridgeBootstrap?.platform);
  } catch (_) {
    return CLIENT_PLATFORM_WEB;
  }
}

function readStoredClientPlatform() {
  try {
    return normalizeClientPlatform(window.sessionStorage.getItem(CLIENT_PLATFORM_SESSION_STORAGE_KEY));
  } catch (_) {
    return CLIENT_PLATFORM_WEB;
  }
}

function writeStoredClientPlatform(value) {
  try {
    window.sessionStorage.setItem(CLIENT_PLATFORM_SESSION_STORAGE_KEY, normalizeClientPlatform(value));
  } catch (_) {
    // Ignore storage failures.
  }
}

function readClientPlatformFromUrl() {
  try {
    const url = new URL(window.location.href);
    const clientValues = url.searchParams.getAll("client").map((value) => normalizeClientPlatform(value));
    if (clientValues.includes(CLIENT_PLATFORM_ANDROID_TWA)) {
      return CLIENT_PLATFORM_ANDROID_TWA;
    }

    const sourceValues = url.searchParams.getAll("source").map((value) => String(value || "").trim().toLowerCase());
    if (sourceValues.includes("android_notification")) {
      return CLIENT_PLATFORM_ANDROID_TWA;
    }
  } catch (_) {
    // Ignore URL parsing failures.
  }

  return CLIENT_PLATFORM_WEB;
}

export function resolveClientPlatform() {
  if (typeof window === "undefined") {
    return CLIENT_PLATFORM_WEB;
  }

  const bootstrappedPlatform = readBootstrappedClientPlatform();
  if (bootstrappedPlatform === CLIENT_PLATFORM_ANDROID_TWA) {
    writeStoredClientPlatform(bootstrappedPlatform);
    return bootstrappedPlatform;
  }

  const urlPlatform = readClientPlatformFromUrl();
  if (urlPlatform === CLIENT_PLATFORM_ANDROID_TWA) {
    writeStoredClientPlatform(urlPlatform);
    return urlPlatform;
  }

  if (hasBufferedAndroidTwaBridgePort()) {
    writeStoredClientPlatform(CLIENT_PLATFORM_ANDROID_TWA);
    return CLIENT_PLATFORM_ANDROID_TWA;
  }

  return readStoredClientPlatform();
}

export function isAndroidTwaClient() {
  return resolveClientPlatform() === CLIENT_PLATFORM_ANDROID_TWA;
}

export function shouldForceRedirectGoogleSignIn() {
  return isAndroidTwaClient();
}
